import { Component, Input } from "@angular/core";
import { MatRadioChange } from "@angular/material/radio";
import { QuestionnaireQuestion } from "@models/questionnaire_question";

@Component({
	selector: "investor-profile",
	templateUrl: "./investor-profile.component.html",
	styleUrls: ["./investor-profile.component.scss"],
	standalone: false
})
export class InvestorProfileComponent {
	@Input() public question: QuestionnaireQuestion;

	public onRadioChange(change: MatRadioChange): void {
		const radioBtn = change.source;
		const questionId = radioBtn.name;
		const answerId = radioBtn.value;
		const question = this.question.getId() === questionId;
		if (question) {
			this.question.getAnswers().forEach((a) => {
				return a.setSelected(a.getId() === answerId);
			});
		}
	}
}
